/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { ChallengeListInner } from './ChallengeListInner';
import {
    ChallengeListInnerFromJSON,
    ChallengeListInnerFromJSONTyped,
    ChallengeListInnerToJSON,
    ChallengeListInnerToJSONTyped,
} from './ChallengeListInner';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface PostId200Response
 */
export interface PostId200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostId200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostId200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<ChallengeListInner>}
     * @memberof PostId200Response
     */
    result?: Array<ChallengeListInner>;
}

/**
 * Check if a given object implements the PostId200Response interface.
 */
export function instanceOfPostId200Response(value: object): value is PostId200Response {
    return true;
}

export function PostId200ResponseFromJSON(json: any): PostId200Response {
    return PostId200ResponseFromJSONTyped(json, false);
}

export function PostId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostId200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'] == null ? undefined : ((json['result'] as Array<any>).map(ChallengeListInnerFromJSON)),
    };
}

export function PostId200ResponseToJSON(json: any): PostId200Response {
    return PostId200ResponseToJSONTyped(json, false);
}

export function PostId200ResponseToJSONTyped(value?: PostId200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': value['result'] == null ? undefined : ((value['result'] as Array<any>).map(ChallengeListInnerToJSON)),
    };
}

